export default (limitMB, event) => {

  const files = Array.from(event.target.files || event.dataTransfer.files)

  if (files.every(file => file.size < limitMB * 1024 * 1024)) return true

  alert(`${limitMB}MB以上のファイルは選択できません。`)
  event.currentTarget.value = ''
  return false

}